import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import AskQuestionDetailModal from './AskQuestionDetailModal';

/**
 * AskQuestionListItem — 可点击的提问条目
 *
 * 属性：
 *   question   - AskQuestion 模型
 *   targetType - 'discussion' | 'article'
 *
 * 点击打开 AskQuestionDetailModal 弹窗查看详情。
 */
export default class AskQuestionListItem extends Component {
  /** Flarum model shortcut */
  get q() {
    return this.attrs.question;
  }

  /**
   * 判断 AI 标签状态
   * 彩色 = needAi + aiAnswer 存在
   * 灰色 = needAi + aiAnswer 不存在
   * 隐藏 = needAi = false
   */
  get aiTagState() {
    if (!this.q.attribute('needAi')) return 'hidden';
    if (this.q.attribute('aiAnswer')) return 'answered';
    return 'pending';
  }

  /**
   * 判断导师标签状态
   * 彩色 = needMentor + answer 存在
   * 灰色 = needMentor + answer 不存在
   * 隐藏 = needMentor = false
   */
  get mentorTagState() {
    if (!this.q.attribute('needMentor')) return 'hidden';
    if (this.q.attribute('answer')) return 'answered';
    return 'pending';
  }

  getTagClass(base, state) {
    if (state === 'hidden') return base + ' hidden';
    if (state === 'answered') return base + ' ' + base + '--answered';
    return base + ' ' + base + '--pending';
  }

  openDetail() {
    app.modal.show(AskQuestionDetailModal, { question: this.q });
  }

  getRelativeTime(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);
    if (diff < 60) return '刚刚';
    if (diff < 3600) return Math.floor(diff / 60) + '分钟前';
    if (diff < 86400) return Math.floor(diff / 3600) + '小时前';
    if (diff < 2592000) return Math.floor(diff / 86400) + '天前';
    return date.toLocaleDateString('');
  }

  view() {
    const a = (key) => this.q.attribute(key) || '';
    const aiTag = this.aiTagState;
    const mentorTag = this.mentorTagState;
    const question = a('question');

    return (
      <div
        className="AskQuestionListItem"
        onclick={() => this.openDetail()}
      >
        <div className="AskQuestionListItem-header">
          <div className="AskQuestionListItem-question">
            <span className="AskQuestionListItem-text">{question}</span>
            <span className="AskQuestionListItem-time">{this.getRelativeTime(a('createdAt'))}</span>
          </div>
          <div className="AskQuestionListItem-tags">
            <i className="fas fa-chevron-right AskQuestionListItem-arrow"></i>
            {aiTag !== 'hidden' && (
              <span className={this.getTagClass('AskQuestionListItem-tag AskQuestionListItem-tag--ai', aiTag)}>
                AI
              </span>
            )}
            {mentorTag !== 'hidden' && (
              <span className={this.getTagClass('AskQuestionListItem-tag AskQuestionListItem-tag--mentor', mentorTag)}>
                师
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}
